import { render } from "./VGUserVoiceExplorerModal.vue?vue&type=template&id=7961dc18&scoped=true"
import script from "./VGUserVoiceExplorerModal.vue?vue&type=script&lang=js"
export * from "./VGUserVoiceExplorerModal.vue?vue&type=script&lang=js"

import "./VGUserVoiceExplorerModal.vue?vue&type=style&index=0&id=7961dc18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7961dc18"]])

export default __exports__